import classNames from "classnames";
import moment from "moment";
import React from "react";
import { marpolUtils } from "../../../../../redux/app/marpol";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2G1 } from "../../../../../redux/app/bfl-2/groups/bfl2-g";
import CommaSeparator from "../../../../_common/CommaSeparator";
import { commonUtils } from "../../../../../redux/_common";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2G1PreviewProps = OwnProps;
function BFL2G1Preview(props: BFL2G1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2G1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "G", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, 4, renderItem4()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.locationWhereShipLaidUp
					? biofoulingRecord.item1.locationWhereShipLaidUp
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.contingencyActions
					? biofoulingRecord.item2.contingencyActions
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item3.precautionsTaken
					? biofoulingRecord.item3.precautionsTaken
					: "-----"}
			</h4>
		);
	}
	function renderItem4() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item4.dateWhenShipReturnedToNormal
					? `${moment(
							biofoulingRecord.item4.dateWhenShipReturnedToNormal
					  ).format("DD-MMM-YYYY")} (SMT)`
					: "-----"}
			</h4>
		);
	}

	return renderMain();
}

export default BFL2G1Preview;
